import React from 'react';
import TooltipBody from 'modules/emergencies/components/ui/texts/TooltipBody';

export const QuoteTooltip = (props) => {
  const ticket = props.ticket;

  let messages = [];

  if (!ticket?.assigned_to?.id) {
    messages.push('It is necessary to assign an agent first');
  }

  if (!!ticket?.draft_error_messages) {
    messages.push(...ticket.draft_error_messages);
  }

  if (!messages) {
    return (
      <>
        <TooltipBody />
      </>
    );
  }

  return (
    <>
      {messages.map((message) => (
        <TooltipBody key={message}>• {message}</TooltipBody>
      ))}
    </>
  );
};
